import React__default from 'react';
import { Direction } from '@keepeek/commons';
import { Box } from '@mui/material';
import SanitizeHtml from '../../SanitizeHtml/index.js';

var convertToSortElement = function (i18nSorts, KIcon) {
    return i18nSorts.map(function (sort) {
        return {
            label: (React__default.createElement(Box, { "aria-label": "".concat(sort.translation, " ").concat(sort.directionTranslation), sx: { display: "flex", gap: 1, alignItems: "center" } },
                React__default.createElement(SanitizeHtml, { html: sort.translation }),
                Direction.Asc === sort.direction ? (React__default.createElement(KIcon, { "aria-label": sort.directionTranslation, className: "fa-solid fa-arrow-up" })) : (React__default.createElement(KIcon, { "aria-label": sort.directionTranslation, className: "fa-solid fa-arrow-down" })))),
            value: sort.value
        };
    });
};

export { convertToSortElement };
//# sourceMappingURL=utils.js.map
